// extracted by mini-css-extract-plugin
module.exports = {"invalidEmail":"EditableRequisitionEmail_invalidEmail__ffGe5","submitButton":"EditableRequisitionEmail_submitButton__1iKnh","feedback":"EditableRequisitionEmail_feedback__JS0LV"};